import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.3914 44.5499C78.3914 44.5499 59.7114 34.2999 55.6614 29.5699C51.1614 24.3099 51.3614 1.66992 51.3614 1.66992H38.9414C38.9414 1.66992 39.2514 24.4199 34.6414 29.5699C29.7514 35.0299 11.6914 43.8899 11.6914 43.8899C17.8814 58.4699 35.6214 68.1699 45.1614 68.1699C54.7014 68.1699 72.2014 59.1299 78.3914 44.5499Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.6912 59.3799C84.8312 48.0199 81.4812 44.8999 76.8112 42.6699L45.0312 60.5199L13.2512 42.6699C8.58119 44.8999 4.95119 48.3399 3.37119 59.3799C1.74119 70.7399 1.45117 72.4499 1.45117 72.4499H88.6012C88.6112 72.4499 88.3612 69.5899 86.6912 59.3799Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M66.5513 44.0498C66.5513 44.0498 67.2113 48.9698 62.0813 51.8598C62.0813 51.8598 60.6413 47.1298 66.5513 44.0498Z"
        fill="#B7C33E"
      />
      <path
        d="M52.6207 54.3799C52.6207 54.3799 55.4807 58.4299 52.2907 63.3699C52.2907 63.3599 48.8207 59.8399 52.6207 54.3799Z"
        fill="#559D4D"
      />
      <path
        d="M45.6009 55.4497C45.6009 55.4497 46.2509 60.3697 41.1309 63.2497C41.1309 63.2497 39.7009 58.5197 45.6009 55.4497Z"
        fill="#B7C33E"
      />
      <path
        d="M28.5713 52.8298C28.5713 52.8298 28.6713 47.8698 34.1713 45.7898C34.1713 45.7998 34.8713 50.6898 28.5713 52.8298Z"
        fill="#B7C33E"
      />
      <path
        d="M21.8506 50.9099C21.8506 50.9099 21.9806 45.9499 27.5006 43.9099C27.5106 43.9199 28.1706 48.8099 21.8506 50.9099Z"
        fill="#5A7036"
      />
      <path
        d="M22.3009 45.6498C22.3009 45.6498 18.5909 42.3498 20.5909 36.8198C20.5909 36.8198 24.7709 39.4698 22.3009 45.6498Z"
        fill="#559D4D"
      />
      <path
        d="M42.1611 52.1899C42.1611 52.1899 44.2311 47.6799 50.1111 47.9799C50.1011 47.9799 48.7911 52.7399 42.1611 52.1899Z"
        fill="#5A7036"
      />
      <path
        d="M17.0605 55.7099C17.0605 55.7099 19.1306 51.1999 25.0106 51.4999C25.0006 51.4999 23.6905 56.2599 17.0605 55.7099Z"
        fill="#5A7036"
      />
      <path
        d="M31.9006 61.37C31.9006 61.37 27.9406 58.38 29.4906 52.71C29.4906 52.71 33.8606 55.01 31.9006 61.37Z"
        fill="#559D4D"
      />
      <path
        d="M15.7109 47.1997C15.7109 47.1997 10.9209 48.4997 7.38086 43.7997C7.38086 43.7997 11.8809 41.7497 15.7109 47.1997Z"
        fill="#B7C33E"
      />
      <path
        d="M75.8408 42.9798C75.8408 42.9798 77.4708 38.2998 83.3508 38.0298C83.3508 38.0298 82.5008 42.8998 75.8408 42.9798Z"
        fill="#5A7036"
      />
      <path
        d="M69.4912 52.0499C69.4912 52.0499 73.9612 49.8899 78.3012 53.8599C78.3012 53.8499 74.2512 56.6899 69.4912 52.0499Z"
        fill="#5A7036"
      />
      <path
        d="M78.9104 40.3497C78.9104 40.3497 80.7204 39.9497 81.5204 41.9097C82.3204 43.8597 83.4804 46.2197 81.5804 46.3697C81.5804 46.3697 83.3704 48.5997 81.9504 49.5897C80.5304 50.5797 77.2804 52.3597 76.6004 50.8997C76.6004 50.8997 75.4204 53.4597 73.5704 52.9097C71.7204 52.3597 69.2104 50.5297 70.5204 48.5897C70.5204 48.5897 68.7304 48.5997 68.9504 46.5997C69.1704 44.5997 69.0904 41.6597 70.1404 41.4197C71.2004 41.1697 71.6304 42.1397 71.6304 42.1397C71.6304 42.1397 70.5004 39.5197 73.0404 39.4197C75.5904 39.3197 78.6404 37.4397 78.9104 40.3497Z"
        fill="#F9C4B8"
      />
      <path
        d="M77.2802 43.4097C77.2802 43.4097 77.2502 45.3897 78.8102 46.1697C78.8102 46.1697 76.7002 47.2397 76.1802 48.8297C76.1802 48.8297 74.9102 46.6797 73.2002 46.2997C73.2002 46.2997 74.6602 45.6897 74.4302 43.6697C74.4302 43.6697 76.3502 44.7997 77.2802 43.4097Z"
        fill="#F5A18C"
      />
      <path
        d="M14.641 41.0599C14.641 41.0599 14.991 39.2399 17.101 39.2799C19.211 39.3199 21.841 39.19 21.221 40.99C21.221 40.99 23.971 40.2299 24.321 41.9299C24.671 43.6299 25.011 47.3099 23.401 47.3599C23.401 47.3599 25.291 49.4599 24.041 50.9399C22.791 52.42 20.131 53.9999 18.871 52.0299C18.871 52.0299 18.171 53.68 16.421 52.68C14.671 51.68 11.941 50.5899 12.141 49.5299C12.331 48.4599 13.401 48.4499 13.401 48.4499C13.401 48.4499 10.551 48.4499 11.471 46.0699C12.381 43.6899 11.861 40.1499 14.641 41.0599Z"
        fill="#F9C4B8"
      />
      <path
        d="M16.8109 43.77C16.8109 43.77 18.6209 44.58 19.9609 43.46C19.9609 43.46 20.1009 45.83 21.3609 46.94C21.3609 46.94 18.8809 47.25 17.8509 48.66C17.8509 48.66 17.8709 47.07 15.9209 46.48C15.9209 46.49 17.7109 45.17 16.8109 43.77Z"
        fill="#F5A18C"
      />
      <path
        d="M43.4708 54.0599C43.4708 54.0599 44.7508 55.3999 43.4808 57.0999C42.2208 58.7899 40.8008 61.0099 39.6908 59.4599C39.6908 59.4599 38.7108 62.1399 37.1208 61.4399C35.5408 60.7399 32.3408 58.8699 33.2308 57.5399C33.2308 57.5399 30.4308 57.8599 29.9508 55.9799C29.4708 54.1099 29.7308 51.0199 32.0708 51.1399C32.0708 51.1399 31.1408 49.6199 32.9708 48.7699C34.8008 47.9199 37.2708 46.3399 38.0308 47.1199C38.7908 47.8999 38.1808 48.7699 38.1808 48.7699C38.1808 48.7699 39.8408 46.4499 41.2408 48.5799C42.6408 50.6899 45.8308 52.3299 43.4708 54.0599Z"
        fill="#F9C4B8"
      />
      <path
        d="M40.011 54.2399C40.011 54.2399 38.301 55.2399 38.431 56.9799C38.431 56.9799 36.421 55.7199 34.791 56.0999C34.791 56.0999 35.981 53.8999 35.421 52.2399C35.421 52.2399 36.701 53.1799 38.311 51.9399C38.321 51.9399 38.351 54.1599 40.011 54.2399Z"
        fill="#F5A18C"
      />
      <path
        d="M53.591 49.4398C53.591 49.4398 53.671 47.5898 55.771 47.3298C57.861 47.0598 60.441 46.5498 60.101 48.4298C60.101 48.4298 62.711 47.2798 63.301 48.9098C63.891 50.5398 64.771 54.1398 63.181 54.4098C63.181 54.4098 65.351 56.2098 64.341 57.8598C63.321 59.5098 60.911 61.4598 59.381 59.6898C59.381 59.6898 58.931 61.4198 57.051 60.6898C55.171 59.9598 52.321 59.2798 52.351 58.1898C52.381 57.0998 53.441 56.9398 53.441 56.9398C53.441 56.9398 50.621 57.3498 51.181 54.8698C51.741 52.3698 50.711 48.9398 53.591 49.4398Z"
        fill="#F9C4B8"
      />
      <path
        d="M56.1314 51.8098C56.1314 51.8098 58.0414 52.3498 59.2014 51.0498C59.2014 51.0498 59.6914 53.3698 61.0914 54.2798C61.0914 54.2798 58.6814 54.9498 57.8714 56.4998C57.8714 56.4998 57.6614 54.9298 55.6514 54.6298C55.6414 54.6198 57.2214 53.0598 56.1314 51.8098Z"
        fill="#F5A18C"
      />
      <path
        d="M65.0509 48.4498C65.0509 48.4498 65.2409 47.1398 66.7509 47.0998C68.2609 47.0598 70.1309 46.8898 69.7509 48.1998C69.7509 48.1998 71.6909 47.5698 71.9909 48.7698C72.2909 49.9698 72.6509 52.5998 71.5109 52.6798C71.5109 52.6798 72.9209 54.1198 72.0809 55.2198C71.2409 56.3198 69.3809 57.5298 68.4209 56.1598C68.4209 56.1598 67.9709 57.3598 66.6909 56.6998C65.4009 56.0398 63.4209 55.3498 63.5309 54.5798C63.6309 53.8098 64.3909 53.7698 64.3909 53.7698C64.3909 53.7698 62.3509 53.8598 62.9309 52.1298C63.5209 50.3998 63.0309 47.8898 65.0509 48.4498Z"
        fill="#E3BAD7"
      />
      <path
        d="M66.6809 50.3197C66.6809 50.3197 68.0009 50.8498 68.9209 49.9998C68.9209 49.9998 69.1009 51.6898 70.0309 52.4398C70.0309 52.4398 68.2709 52.7397 67.5809 53.7797C67.5809 53.7797 67.5409 52.6398 66.1309 52.2798C66.1309 52.2898 67.3709 51.2997 66.6809 50.3197Z"
        fill="#C375AF"
      />
      <path
        d="M24.0412 48.0699C24.0412 48.0699 24.2312 46.7599 25.7412 46.7199C27.2512 46.6799 29.1212 46.5099 28.7412 47.8199C28.7412 47.8199 30.6812 47.1899 30.9812 48.3899C31.2812 49.5899 31.6412 52.2199 30.5012 52.2999C30.5012 52.2999 31.9112 53.74 31.0712 54.84C30.2312 55.94 28.3712 57.1499 27.4112 55.7799C27.4112 55.7799 26.9612 56.9799 25.6812 56.3199C24.3912 55.6599 22.4112 54.9699 22.5212 54.1999C22.6212 53.4299 23.3812 53.3899 23.3812 53.3899C23.3812 53.3899 21.3412 53.4799 21.9212 51.7499C22.5112 50.0299 22.0212 47.5099 24.0412 48.0699Z"
        fill="#E3BAD7"
      />
      <path
        d="M25.6711 49.9499C25.6711 49.9499 26.9911 50.4799 27.9111 49.6299C27.9111 49.6299 28.0911 51.3199 29.0211 52.0699C29.0211 52.0699 27.2611 52.3699 26.5711 53.4099C26.5711 53.4099 26.5311 52.2699 25.1211 51.9099C25.1211 51.9099 26.3611 50.9199 25.6711 49.9499Z"
        fill="#C375AF"
      />
      <path
        d="M48.2311 51.1499C48.2311 51.1499 49.3111 50.3799 50.3811 51.4399C51.4511 52.4999 52.8811 53.7299 51.6711 54.3599C51.6711 54.3599 53.4711 55.3199 52.8111 56.3699C52.1511 57.4199 50.5111 59.4999 49.6611 58.7299C49.6611 58.7299 49.6011 60.7499 48.2311 60.8999C46.8511 61.0499 44.6911 60.5599 45.0111 58.9099C45.0111 58.9099 43.8411 59.4199 43.4211 58.0399C43.0011 56.6599 42.1311 54.7499 42.7511 54.2899C43.3811 53.8299 43.9311 54.3499 43.9311 54.3499C43.9311 54.3499 42.4511 52.9399 44.1011 52.1599C45.7611 51.3999 47.2411 49.3099 48.2311 51.1499Z"
        fill="#E3BAD7"
      />
      <path
        d="M48.0109 53.6299C48.0109 53.6299 48.5509 54.9499 49.7909 55.0199C49.7909 55.0199 48.7009 56.3199 48.8009 57.5099C48.8009 57.5099 47.3609 56.4499 46.1309 56.6699C46.1309 56.6699 46.9209 55.8599 46.2009 54.5899C46.2109 54.5899 47.7909 54.7999 48.0109 53.6299Z"
        fill="#C375AF"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.0365"
          y1="40.857"
          x2="45.0365"
          y2="14.8605"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
